import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { BookOutlined } from "@material-ui/icons";
import _ from 'lodash';
import * as React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { IMKSRequestHistoryRecord } from '../../repository/jago/model/output/IMKSRequestDTO';
import ListEmptyView from "../ListEmptyView";
import MKSRequestHistoryRow from './MKSRequestHistoryRow';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});

export interface IMKSRequestHistoryListProps extends WithStyles<typeof styles> {
  history: IMKSRequestHistoryRecord[];
}

class MKSRequestHistoryList extends React.Component<IMKSRequestHistoryListProps, any> {

  public render() {
    const { history: historyData } = this.props;
    return (
      <div style={{ zIndex: 100 }}>
        {!historyData || (historyData && _.isEmpty(historyData)) ? (
          <ListEmptyView
            icon={<BookOutlined style={{ fontSize: 40 }} />}
            titleKeyMessage="mks.noRequestHistoryFound"
            descriptionKeyMessage="mks.noRequestHistoryFoundDescription"
          />
        ) : (
          <InfiniteScroll
            dataLength={_.size(historyData)}
            next={() => null}
            hasMore={false}
            height={800}
            loader={<h4>Loading...</h4>}
          >
            {_.map(_.orderBy(historyData, 'time', 'desc'), history => (
              <MKSRequestHistoryRow key={history.time} history={history} />
            ))}
          </InfiniteScroll>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(MKSRequestHistoryList);
